"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewWalletFromMnemonic = exports.GetSigTypeFromCoinType = exports.GetCoinTypeFromSigType = exports.BIP44 = exports.HDWallet = exports.validMnemonic = exports.randomMnemonic = void 0;
const bip32_1 = require("bip32");
const bip39 = __importStar(require("bip39"));
const ed25519_hd_key_1 = require("ed25519-hd-key");
const core_1 = require("../core");
const bip44path = __importStar(require("./path"));
__exportStar(require("./path"), exports);
// DO NOT IMPORT tiny-secp256k1. Doing so will break browser apps.
const HDSigCoin = new Map([
    [core_1.SignatureType.RCD1, bip44path.CoinType.FactomFactoids],
    [core_1.SignatureType.ED25519, bip44path.CoinType.Accumulate],
    [core_1.SignatureType.BTC, bip44path.CoinType.Bitcoin],
    [core_1.SignatureType.ETH, bip44path.CoinType.Ether],
]);
const HDCoinSig = new Map([
    [bip44path.CoinType.FactomFactoids, core_1.SignatureType.RCD1],
    [bip44path.CoinType.Accumulate, core_1.SignatureType.ED25519],
    [bip44path.CoinType.Bitcoin, core_1.SignatureType.BTC],
    [bip44path.CoinType.Ether, core_1.SignatureType.ETH],
]);
function randomMnemonic() {
    return bip39.generateMnemonic();
}
exports.randomMnemonic = randomMnemonic;
function validMnemonic(mnemonic) {
    return bip39.validateMnemonic(mnemonic);
}
exports.validMnemonic = validMnemonic;
class HDWallet {
    constructor(options) {
        // Ensure TypeScript understands that 'options' is not an empty object
        if (!options || typeof options !== "object") {
            throw new Error("Options must be provided and must be an object");
        }
        this.bip32 = (0, bip32_1.BIP32Factory)(options.secp256k1);
        this.signatureType = options.signatureType;
        this.seed = Buffer.alloc(0);
        if (options.mnemonic) {
            const passwd = options.passphrase || "";
            this.seed = bip39.mnemonicToSeedSync(options.mnemonic, passwd);
        }
        else if (options.seed) {
            if (typeof options.seed === "string") {
                this.seed = Buffer.from(options.seed, "hex");
            }
            else {
                this.seed = options.seed;
            }
        }
    }
    // derive a key for a specific path for the particular coin type
    deriveKey(path) {
        const d = new bip44path.Derivation(inferDerivationCurve(this.signatureType));
        d.fromPath(path);
        if (d.getCoinType() !== GetCoinTypeFromSigType(this.signatureType)) {
            throw new Error(`error path coin type ${d.getCoinType()} does not match expected for signature type ${this.signatureType}`);
        }
        d.validate();
        if (this.signatureType === core_1.SignatureType.ED25519) {
            const bipkey = (0, ed25519_hd_key_1.derivePath)(path, this.seed.toString("hex"));
            return {
                privateKey: bipkey.key,
                signatureType: this.signatureType,
            };
        }
        else {
            //for all other secp256k1 derivations:
            const hdWallet = this.bip32.fromSeed(this.seed);
            const bipkey = hdWallet.derivePath(path);
            return {
                privateKey: bipkey.privateKey,
                signatureType: this.signatureType,
            };
        }
    }
}
exports.HDWallet = HDWallet;
/**
 * The caller must provide the Secp256k1 implementation. This allows browsers to
 * work around the issues caused by WASM implementations like tiny-secp256k1.
 */
class BIP44 extends HDWallet {
    constructor(secp256k1, signatureType, mnemonic, passphrase) {
        super({ secp256k1, mnemonic, passphrase, signatureType });
    }
    //getKey: account will be hardened if it isn't. Change and Address will be hardened only if slip-10 derivation is needed
    getKey(account, change, address) {
        const coin = GetCoinTypeFromSigType(this.signatureType);
        return this.deriveKey(bip44path.makePath(coin, account, change, address));
    }
    getKeyFromPath(path) {
        return this.deriveKey(path);
    }
}
exports.BIP44 = BIP44;
function inferDerivationCurve(sigType) {
    return sigType === core_1.SignatureType.ED25519
        ? bip44path.Curve.CurveEd25519
        : bip44path.Curve.CurveSecp256k1;
}
function GetCoinTypeFromSigType(sigType) {
    // Ensure the numeric value corresponds to a valid enum value
    if (typeof sigType === "number" && sigType in core_1.SignatureType) {
        // Retrieve the corresponding CoinType using the enum value
        const ret = HDSigCoin.get(sigType);
        if (ret === undefined) {
            throw new Error(`coin type ${sigType} not found in signature mapping`);
        }
        return ret;
    }
    else {
        throw new Error(`Invalid value for SignatureType: ${sigType}`);
    }
}
exports.GetCoinTypeFromSigType = GetCoinTypeFromSigType;
function GetSigTypeFromCoinType(coin) {
    if (coin in bip44path.CoinType) {
        const ret = HDCoinSig.get(coin);
        if (ret === undefined) {
            throw new Error(`coin type ${coin} not found in signature mapping`);
        }
        return ret;
    }
    else {
        throw new Error(`Invalid value for CoinType: ${coin}`);
    }
}
exports.GetSigTypeFromCoinType = GetSigTypeFromCoinType;
function NewWalletFromMnemonic(secp256k1, mnemonic, coin, passphrase) {
    return new BIP44(secp256k1, GetSigTypeFromCoinType(coin), mnemonic, passphrase);
}
exports.NewWalletFromMnemonic = NewWalletFromMnemonic;
//# sourceMappingURL=index.js.map